import { ChoiceDto } from './choiceTypes';
import { ColumnDto, ColumnRequest } from './columnTypes';
import { Positioned } from './positionedTypes';

export interface BaseQuestion {
  description?: string,
  enableComment: boolean,
  question?: string,
  choices?: ChoiceDto[],
  questionType: QuestionType,
}

export interface QuestionRequest extends BaseQuestion {
  columns?: ColumnRequest[],
}

export interface QuestionDto extends BaseQuestion, Positioned {
  id: number,
  columns?: ColumnDto[]
}

export function emptyQuestionRequest(): QuestionRequest {
  return {
    description: '',
    enableComment: false,
    question: undefined,
    choices: undefined,
    columns: undefined,
    questionType: QuestionType.TEXT
  }
}

export function emptyQuestionDto(): QuestionDto {
  return {
    id: -1,
    description: '',
    enableComment: false,
    question: undefined,
    choices: undefined,
    columns: undefined,
    questionType: QuestionType.TEXT,
    position: -1
  }
}

export enum QuestionType {
  TEXT = 'TEXT',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  MULTIPLE_COLUMNS = 'MULTIPLE_COLUMNS'
}
